import React from 'react'
import {useMutation} from '@apollo/client'
import {CART_LINES_ADD, CartConsumer, CREATE_CART} from '../../services/shopify'
import {classList} from '../../services/util'
import {trackAddToCart} from '../../services/analytics'
import Button from '../Button'
import {LoadingConsumer} from '../LoadingWrapper'
import './styles.scss'

export default function CheckoutButton({className, children, lineItems, onSuccess}) {
  const [createCart] = useMutation(CREATE_CART)
  const [cartLinesAdd] = useMutation(CART_LINES_ADD)
  return <LoadingConsumer>
    {({addLoad, removeLoad}) => <CartConsumer>
      {({cart, toggleCart, updateCart}) => <Button
        className={classList(['CheckoutButton', className])}
        disabled={!lineItems || lineItems.length < 1}
        onClick={() => {
          addLoad('checkoutButton')
          const promise = !cart ? createCart({
            variables: {
              cartInput: {
                lines: lineItems,
              },
            }
          }).then(res => res.data.cartCreate) : cartLinesAdd({
            variables: {
              cartId: cart.id,
              lines: lineItems,
            }
          }).then(res => res.data.cartLinesAdd)
          promise.then(res => {
            updateCart(res.cart)
            removeLoad('checkoutButton')
            trackAddToCart()
            if (onSuccess) onSuccess()
            toggleCart(true)
          })
        }}>{children}</Button>}
    </CartConsumer>}
  </LoadingConsumer>
}
